import { TextButton } from '@wix/design-system';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsRtl } from '../../../../hooks';

export interface IBackTextButton {
  goBack: () => void;
}

export const BackTextButton: React.FC<IBackTextButton> = observer(
  ({ goBack }) => {
    const { t } = useTranslation();
    const isRtl = useIsRtl();
    return (
      <TextButton
        skin="dark"
        prefixIcon={isRtl ? <ChevronRight /> : <ChevronLeft />}
        onClick={goBack}
      >
        {t('multiFactorAuth.addAuthApp.codeModal.backButton')}
      </TextButton>
    );
  },
);
